<template>
  <div class="modalApp" v-if="editDialogVisible">
    <el-dialog :title="$lang(diglogTitle)" :visible.sync="editDialogVisible" width="800px" @close="handleClose" :modal-append-to-body="false"
               :close-on-click-modal="false">

     <el-form class="el-form-edit" :inline="true" label-position="left">
       <el-row :gutter="20">
         <el-col :span="24" class="waybillNo">
              {{ $lang('运单号') + ' :'}}
             <span class="blue1" @click="getExpressTracking(modalData.waybillNo)">{{ modalData.waybillNo }}</span>
         </el-col>
       </el-row>
       <el-row class="address">
         <div class="address_list">
           <div class="list_left">{{$lang('寄')}}</div>
           <div class="list_right">
             <div class="top1">
               <span class="name">{{ modalData.senderName }}</span>
               <span class="phone">{{ modalData.senderMobilePhone }}</span>
             </div>
             <div class="ads">{{ modalData.senderProvinceName + modalData.senderCityName + modalData.senderAreaName }}</div>
           </div>
         </div>
         <div class="address_list">
           <div class="list_left left2">{{$lang('收')}}</div>
           <div class="list_right">
             <div class="top1">
               <span class="name">{{ modalData.receiverName }}</span>
               <span class="phone">{{ modalData.receiverMobilePhone }}</span>
             </div>
             <div class="ads">{{ modalData.receiverProvinceName + modalData.receiverCityName + modalData.receiverAreaName }}</div>
           </div>
         </div>
       </el-row>
       <el-row :gutter="20" style="margin-top: 30px">
         <el-col :span="6">
           <el-form-item style="width: 100% !important;" prop="waybillNo" :label="$lang('回电号码') + ':'">
             <div class="red">{{ modalData.customerPhone }}</div>
           </el-form-item>
         </el-col>
         <el-col :span="6">
           <el-form-item style="width: 100% !important;" prop="waybillNo" :label="$lang('一级类型') + ':'">
             <div class="black">{{ modalData.firstTypeName }}</div>
           </el-form-item>
         </el-col>
         <el-col :span="10">
           <el-form-item style="width: 100% !important;" prop="waybillNo" :label="$lang('二级类型') + ':'">
             <div class="black">{{ modalData.secondTypeName }}</div>
           </el-form-item>
         </el-col>
       </el-row>
       <el-row :gutter="20">
         <el-col :span="24">
           <el-form-item style="width: 100% !important;" prop="waybillNo" :label="$lang('问题描述') + ':'">
             <div class="black">{{ modalData.problemDescription }}</div>
           </el-form-item>
         </el-col>
       </el-row>
       <el-row :gutter="20">
         <el-col :span="24">
           <el-form-item style="width: 100% !important;" prop="waybillNo" :label="$lang('处理结果') + ':'">
             <div class="black">{{ modalData.handlingOpinions }}</div>
           </el-form-item>
         </el-col>
       </el-row>
     </el-form>
     <div slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="handleClose('tableForm')">{{$lang('关 闭')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    editDialogVisible: {
      type: Boolean,
      default: true
    },
    modalData: {
      default: {}
    }
  },
  data() {
    return {
      diglogTitle: '问题报告',
    }
  },
  created() {

  },
  methods: {
    handleClose() {
      this.$emit('closeMoadl')
    },
    getExpressTracking(waybillId) {
      if (!waybillId) return
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    }
  }
}
</script>

<style scoped lang="scss">
.modalApp ::v-deep .el-input {
  width: 100% !important;
}
.modalApp ::v-deep .el-step__title {
  color: #333;
  font-size: 14px;
}

.modalApp ::v-deep .el-step__description {
  font-size: 14px;
  color: #666;
}
.modalApp ::v-deep .el-dialog__body {
  padding: 20px 40px;
}

.dialog-footer{
  display: flex;
  justify-content: center;
}
.waybillNo{
  .blue1{
    color: #0778e8;
  }
}

.address{
  padding: 20px 0 30px 0;
  border-bottom: 1px dashed #ccc;
  .address_list{
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .list_left{
      font-size: 18px;
      width: 55px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: #FFFFFF;
      border-radius: 50%;
      background-color: #af1818;
    }
    .left2{
      color: #af1818;
      background-color: #FFFFFF;
      border: 1px solid #af1818;
    }
    .list_right{
      margin-left: 10px;
      .top1{
        .name{
          font-weight: 800;
          color: #222;
        }
        .phone{
          margin-left: 20px;
          font-size: 13px;
        }
      }
      .ads{
        margin-top: 8px;

      }
    }
  }
}

.red {
  color: red;
}
.black {
  color: #222;
}
.close_btn{
  width: 100px;
  background-color: red;
  color: #fff;
}
</style>
